import React from 'react';

export type BoxParams = {
  letter: string;
  answer?: string;
  index?:number;
};

const Box = ({letter, answer, index = 0}:BoxParams) => {
  const classNames = ['Box'];
  switch(answer) {
    case 'PERFECT':
      classNames.push('correct')
      break;
    case 'WRONG_POS':
      classNames.push('correctButWrongPlace')
      break;
    case 'NO':
      classNames.push('done')
      break;
    }

  if(letter && !answer) {
    classNames.push('try')
  }

  return (
    <div className={classNames.join(' ')} style={{
      transitionDelay: !answer ? '0s' : `${index*0.14 ?? 0}s`,
    }}>
      <span className={answer ? 'animateIn' : ''} style={{
        animationDelay: `${index*0.14 ?? 0}s`
      }}>
        {letter}
      </span>
    </div>
  )
}

export default Box;
